import { isPlatformBrowser } from "@angular/common";
import { Component, DestroyRef, Inject, Input, OnInit, PLATFORM_ID } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateService } from "@shared-services/translate.service";
import { ReferenceConst } from "@core-constants/reference.const";
import { Environment } from "@environments";
import { Initiatives, EInitiatives } from "@core-constants/initiatives.const";
import { RedeemManager } from "@core-managers/redeem.manager";
import { IInitiative } from "@shared-base/generic-clases.base";
import { AssetsService } from "@shared-services/assets.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-initiatives-confirm',
  templateUrl: './initiatives-confirm.component.html',
  styleUrls: ['./initiatives-confirm.component.css']
})
export class InitiativesConfirmComponent implements OnInit
{
  public whatsAppUrl: string = ReferenceConst.WhatsAppUrl;
  public initiativeId: string | null = null;
  public selectedInitiative: IInitiative | undefined;

  @Input({ required: true }) public dudaSetupUrl!: string;
  constructor(@Inject(PLATFORM_ID) private platformId,
    private titleService: Title, private router: Router,
    protected redeemManager: RedeemManager,
    private assetsService: AssetsService,
    public translateService: TranslateService,
    private destroyRef$: DestroyRef
  ) { }

  public ngOnInit(): void
  {
    if (isPlatformBrowser(this.platformId))
    {
      this.initiativeId = this.redeemManager.initiativeId;

      this.loadSelectedInitiative();
    }
    
    this.registerLanguageEventListeners();
  }

  private loadSelectedInitiative(): void
  {
    const baseInitiative = Initiatives.find(item => item.id === (this.redeemManager.initiativeId as unknown as EInitiatives));

    const pathBlob = this.assetsService.getAssetFromBlob("");
    const lang = this.translateService.languageCode.toLocaleLowerCase();

    if (!baseInitiative)
    {
      return;
    }

    this.selectedInitiative = {
      ...baseInitiative,
      title: this.translateService.getElement(
        baseInitiative.title,
        pathBlob,
        lang,
        pathBlob,
        lang
      )
    };

    this.titleService.setTitle(`${this.translateService.getElement(baseInitiative.label)} | Akky`);
  }

  private registerLanguageEventListeners(): void
  {
    this.translateService.onTranslateChange()
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe({
        next: () => this.loadSelectedInitiative()
      });
  }

  public onGoToEditSiteClick(): void
  {
    if (isPlatformBrowser(this.platformId))
    {
      window.open(this.dudaSetupUrl, "_blank");
    }
  }

  public onGoToPanel(): void
  {
    if (isPlatformBrowser(this.platformId))
    {
      window.location.href = `${Environment.PortalAkkyURL}jsf/control_panel/start.jsf`;
    }
  }

  public onCloseConfirmationModalClick(): void
  {
    this.router.navigate(['/']);
  }
}
